import { gql } from "@apollo/client";

export const FORCE_RESET_RESEND_PWD = gql`
  mutation resetPassword($password: String!) {
    forceResetPassword(password: $password) {
      id
    }
  }
`;
